import React from "react";
import { makeStyles } from '@material-ui/styles';

import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import I18n from "../../../base/i18n.js.jsx";
import Container from "../../../base/components/container.js.jsx";
import Routes from "../../routes.js.jsx";
import ButtonLink from "../../../base/links/button_link.js.jsx";

import MybilioTextLogoBronze from "../../../resources/logo/mybilio_text_logo_bronze.js";

const pageStyles = makeStyles(theme => ({
  root: {
    padding: "75px 16px",
    ['@media (max-width: 768px)']: {
      padding: "50px 24px",
    },
  },
  img: {
    display: "block",
    margin: "50px auto",
    maxWidth: "500px",
    ['@media (max-width: 992px)']: {
      width: "80%"
    },
    ['@media (max-width: 768px)']: {
      maxWidth: "300px",
      margin: "0px auto",
    },
  },
  title: {
    fontSize: "32px",
    lineHeight: "1",
    textTransform: "uppercase",
    textAlign: "center",
    padding: "28px 0",
    ['@media (max-width: 768px)']: {
      fontSize: "20px",
      padding: "40px 0 24px",
    },
  },
  text: {
    fontSize: "18px",
    fontWeight: theme.typography.fontWeightLight,
    lineHeight: "1.5",
    maxWidth: "415px",
    margin: "auto",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      textAlign: "left",
    },
  },
  button: {
    display: "block",
    fontSize: "20px",
    margin: "50px auto",
    maxWidth: "312px",
    padding: "12px 20px",
    textAlign: "center",
    width: "100%",
    ['@media (max-width: 768px)']: {
      margin: "32px auto 0px",
    },
  },
}));

const ThankYouPage = () => {

  const classes = pageStyles();

  return (
    <Container className = { classes.root } >
      <MybilioTextLogoBronze className = { classes.img } />
      <div className = { classes.title }>
        { I18n.t("web.page.thank_you.title") }
      </div>
      <div className = { classes.text }>
        { I18n.t("web.page.thank_you.text") }
      </div>
       <ButtonLink className = { classes.button }
                   to = { Routes.index() } >
        { I18n.t("action.back_to_home") }
      </ButtonLink>
    </Container>
  );
}

export default compose(withRouter)(ThankYouPage);
